$(document).ready(function (){
    $('.search-form select').select2({
       width: '100%',
    });
});
